import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Comune, StaticUrls } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Provincia } from '../models/provincia';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class ComuneService {

	private comuni: Comune[];
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp) { }

	check(nomeComune: string): Observable<boolean> {
		return this.http.get(StaticUrls._checkComune(nomeComune))
			.map(this.handleResponse)
			.catch(this.handleError);
	}

	getAll(): Observable<Comune[]> {
		return this.http.get(StaticUrls._getComune, this.options)
			.map(this.handleData)
			.catch(this.handleError);

	}

	getByProvincia(listProvincia: Provincia[]): Observable<Comune[]> {
		return this.http.post(StaticUrls._getComuniByProvincia, JSON.stringify(listProvincia), this.options)
			.map(this.handleData)
			.catch(this.handleError);

	}

	private handleData(res: Response){
		this.comuni = res.json();
		return this.comuni;
	}

	private handleResponse(response: Response) {
		if(response.status === 200){
			return true;
		} else {
			return false;
		}
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/comune.service.ts